import {
  REMOVE_CAR_REQUEST,
  REMOVE_CAR_SUCCESS,
  REMOVE_CAR_FAILURE,
  CLEAR_REMOVE_CAR_REQUEST_STATUS,
} from '../../types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_CAR_REQUEST:
      return {
        isLoading: true,
        isLoaded: false,
        error: false,
        errorMessage: null,
      };
    case REMOVE_CAR_SUCCESS:
      return {
        isLoading: false,
        isLoaded: true,
        error: false,
        errorMessage: null,
      };
    case REMOVE_CAR_FAILURE:
      return {
        isLoading: false,
        isLoaded: true,
        error: true,
        errorMessage: action.payload,
      };
    case CLEAR_REMOVE_CAR_REQUEST_STATUS:
      return {
        isLoading: false,
        isLoaded: false,
        error: false,
        errorMessage: null,
      };
    default:
      return state;
  }
};
